import { Link } from 'react-router-dom';

export default function HomePage() {
  return (
    <div className='bg-gray-50 min-h-screen flex flex-col'>
      <header className='bg-blue-600 text-white p-4 shadow-md'>
        <div className='container mx-auto'>
          <h1 className='text-3xl font-bold'>Todo App</h1>
        </div>
      </header>
      <main className='container mx-auto flex-1 flex flex-col items-center justify-center mt-10'>
        <section className='text-center'>
          <h2 className='text-4xl font-semibold mb-4'>
            Manage Your Tasks Efficiently
          </h2>
          <p className='text-lg text-gray-700 mb-6'>
            Our app helps you stay organized and focused.
          </p>
          <Link to={'/todos'}>
            <button className='bg-blue-600 text-white py-3 px-6 rounded-full hover:bg-blue-500 transition'>
              Get Started
            </button>
          </Link>
        </section>
        <section
          id='features'
          className='mt-16 grid grid-cols-1 md:grid-cols-2 gap-8'
        >
          <div className='p-6 bg-white shadow-md rounded text-center'>
            <h3 className='text-xl font-semibold mb-2'>Simple Interface</h3>
            <p className='text-gray-600'>Easy to use with intuitive design.</p>
          </div>
          <div className='p-6 bg-white shadow-md rounded text-center'>
            <h3 className='text-xl font-semibold mb-2'>
              Efficient Task Management
            </h3>
            <p className='text-gray-600'>
              Keep track of your tasks effortlessly.
            </p>
          </div>
        </section>
      </main>
      <footer className='bg-gray-800 text-white p-4 mt-10'>
        <div className='container mx-auto text-center'>
          &copy; 2024 Todo App. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
